import { render, staticRenderFns } from "./PersonReg.vue?vue&type=template&id=54369f4e&scoped=true"
import script from "./PersonReg.vue?vue&type=script&lang=js"
export * from "./PersonReg.vue?vue&type=script&lang=js"
import style0 from "./PersonReg.vue?vue&type=style&index=0&id=54369f4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54369f4e",
  null
  
)

export default component.exports